import { MenuItem } from '@horizontal-org/shira-ui';
import { FiLogOut } from 'react-icons/fi';
import { IoMdHelpCircle, IoMdSettings } from 'react-icons/io';
import { IoPerson } from 'react-icons/io5';
import { LuNotepadText } from 'react-icons/lu';
import { MdMenuBook } from 'react-icons/md';

export const customMenuItems: MenuItem[] = [
  {
    icon: <LuNotepadText id="dashboard-icon" size={24} color="currentColor" data-mirror-rtl />,
    label: 'sidebar.quizzes',
    path: '/dashboard',
  },
  {
    icon: <IoPerson id='learner-icon' size={24} color='currentColor' />,
    label: 'sidebar.learners',
    path: '/learner'
  },
  {
    icon: <MdMenuBook id="templates-icon" size={24} color="currentColor" />,
    label: 'sidebar.templates',
    path: '/template-library'
  },
  {
    icon: <IoMdHelpCircle id="support-icon" size={24} color="currentColor" data-mirror-rtl />,
    label: 'sidebar.support',
    path: '/support',
    position: 'bottom',
  },
  {
    icon: <IoMdSettings id="settings-icon" size={24} color="currentColor" />,
    label: 'sidebar.settings',
    path: '/settings',
    position: 'bottom',
  },
  {
    icon: <FiLogOut id="logout-icon" size={24} color="currentColor" data-mirror-rtl />,
    label: 'sidebar.logout',
    path: '/logout',
    position: 'bottom',
  }
];
